<template>
<!--  <a-card title="自我游" :bodyStyle="{padding: '0 24px 24px'}">-->
<!--    <a-tabs :default-active-key="1" v-model:activeKey="activeKey">-->
<!--      <a-tab-pane :key="1" tab="订单记录">-->
<!--        <OrderRecordsComponent></OrderRecordsComponent>-->
<!--      </a-tab-pane>-->
<!--      <a-tab-pane :key="2" tab="产品更新">-->
<!--        <ProductUpdateComponent ></ProductUpdateComponent>-->
<!--      </a-tab-pane>-->
<!--      <a-tab-pane :key="3" tab="定时任务">-->
<!--        <TaskListComponent></TaskListComponent>-->
<!--      </a-tab-pane>-->
<!--      <a-tab-pane :key="4" tab="屏蔽记录">-->
<!--        <BlockingRecordComponent></BlockingRecordComponent>-->
<!--      </a-tab-pane>-->
<!--      <a-tab-pane :key="5" tab="关联账号" style="margin: 0">-->
<!--        <AssociatedAccountComponent></AssociatedAccountComponent>-->
<!--      </a-tab-pane>-->
<!--    </a-tabs>-->
<!--  </a-card>-->
  <StandardResourceService
    title="自我游抢购"
    v-model="activeTab"
    :tab-list="tabList">
    <OrderRecordsComponent v-if="activeTab==='orderRecord'" proJoinType="41"></OrderRecordsComponent>
    <ProductUpdateComponent
      v-else-if="activeTab==='productUpdate'"
      triggerScheduleUrl="zwy/flashSale/triggerSchedule"
      manualUpdateUrl="zwy/flashSale/manualUpdate"
      proJoinType="41"
    ></ProductUpdateComponent>
    <TaskListComponent v-else-if="activeTab==='taskList'" proJoinType="41"></TaskListComponent>
    <BlockingRecordComponent v-else-if="activeTab==='blockingRecord'" proJoinType="41"></BlockingRecordComponent>
    <AssociatedAccountComponent
      v-else-if="activeTab==='linkAccount'"
      proJoinType="41"
      :showSetting="false"
    ></AssociatedAccountComponent>
  </StandardResourceService>
</template>
<script>
import OrderRecordsComponent from './components/OrderRecordsComponent.vue'
import ProductUpdateComponent from './components/ProductUpdateComponent.vue'
import AssociatedAccountComponent from './components/AssociatedAccountComponent.vue'
import BlockingRecordComponent from './components/BlockingRecordComponent.vue'
import TaskListComponent from './components/TaskListComponent.vue'
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'

export default {
  name: 'ZwyRushHome',
  components: {
    StandardResourceService,
    OrderRecordsComponent,
    ProductUpdateComponent,
    AssociatedAccountComponent,
    TaskListComponent,
    BlockingRecordComponent,
  },
  data(){
    return {
      activeTab:'orderRecord',
      tabList: [
        { label: '订单记录', key: 'orderRecord' },
        { label: '产品更新', key: 'productUpdate' },
        { label: '定时任务', key: 'taskList' },
        { label: '屏蔽记录', key: 'blockingRecord' },
        { label: '关联账号', key: 'linkAccount' },
      ],
      activeKey:1,
    }
  },
  methods:{

  },
}
</script>



<style scoped lang="less">

</style>
